var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"ma-0 pa-0"},[_c('div',{staticClass:"text-body-2"},[_vm._v(" "+_vm._s(_vm.site.city)+" "+_vm._s(_vm.site.district))]),_c('div',{staticClass:"text-body-2"},[_vm._v(_vm._s(_vm.site.address))])])
}
var staticRenderFns = []

export { render, staticRenderFns }